<template>
    <el-row class="template" align="center">
        <el-row class="row title">
            <span @click="backMyPage" class="back-btn"><i class="el-icon el-icon-arrow-left"></i></span>
            <label class="label-title">{{$t("myPage.list.password.changePassword")}}</label>
        </el-row>

        <div class="formPw">
            <el-form :model="form" v-loading="formLoading" :rules="rules" ref="form">
                <el-form-item prop="currentPassword">
                    <label>{{$t("myPage.list.password.currentPassword")}}</label>
                    <el-input type="password" v-model="form.currentPassword"
                              :placeHolder="$t('myPage.list.password.pleaseInputCurrentPassword')"></el-input>
                </el-form-item>
                <el-form-item prop="newPassword">
                    <label>{{$t("myPage.list.password.newPassword")}}</label>
                    <el-input type="password" v-model="form.newPassword"
                              :placeHolder="$t('myPage.list.password.pleaseInputNewPassword')"></el-input>
                </el-form-item>
                <el-form-item prop="confirmNewPassword">
                    <label>{{$t("myPage.list.password.confirmPassword")}}</label>
                    <el-input @keypress.enter.native="submit" type="password" v-model="form.confirmNewPassword"
                              :placeHolder="$t('myPage.list.password.pleaseConfirmNewPassword')"></el-input>
                </el-form-item>
            </el-form>
        </div>

        <div align="center" class="title">
            <el-row>
                <el-button @click="submit" class="btnFoot" style="background-color: #4B86E8" type="primary">
                    {{$t('myPage.list.button.updateBtn')}}
                </el-button>
            </el-row>
            <el-row style="margin-top: 10px">
                <el-button @click="backMyPage" class="btnFoot">{{$t('myPage.list.button.backBtn')}}</el-button>
            </el-row>
        </div>
    </el-row>
</template>

<script>
    import UserAPI from "../../api/user/UserApi";
    import AlertService from "../../service/alert.service";

    export default {
        name: "ChangePassword",

        data() {
            let validateCurrentPassword = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error(this.$t("myPage.list.password.pleaseInputCurrentPassword")));
                }
                callback();
            }
            let validateNewPassword = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error(this.$t("myPage.list.password.pleaseInputNewPassword")));
                } else if (!value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/)) {
                    callback(new Error(this.$t("myPage.list.password.passwordIncorrectFormat")));
                }
                callback();
            }
            let validateConfirmNewPassword = (rule, value, callback) => {
                if (value !== this.form.newPassword) {
                    callback(new Error(this.$t("myPage.list.password.confirmNewPasswordIncorrect")));
                }
                callback();
            }
            return {
                form: {
                    currentPassword: "",
                    newPassword: "",
                    confirmNewPassword: ""
                },
                rules: {
                    currentPassword: [{validator: validateCurrentPassword, trigger: 'blur'}],
                    newPassword: [{validator: validateNewPassword, trigger: 'blur'}],
                    confirmNewPassword: [{validator: validateConfirmNewPassword, trigger: 'blur'}]
                },
                formLoading: false,
            }
        },
        methods: {
            submit() {
                this.$refs['form'].validate(async valid => {
                    if (valid) {
                        try {
                            this.formLoading = true;
                            const changePwRequest = {
                                currentPassword: this.form.currentPassword,
                                newPassword: this.form.newPassword
                            };
                            const result = await UserAPI.changePassword(changePwRequest);
                            if (result) {
                                AlertService.success(this.$t("common.saveSuccess"));
                                this.backMyPage();
                            } else {
                                AlertService.error(this.$t("myPage.list.password.currentPasswordNotEquals"));
                            }
                        } catch (e) {
                            AlertService.error(this.$t("common.serverErrorMessage"), 2000)
                        } finally {
                            this.formLoading = false;
                        }
                    }
                })
            },
            backMyPage() {
                this.$router.push({path: "/myPage"});
                this.clearFormData();
            },
            clearFormData() {
                this.form.currentPassword = null;
                this.form.newPassword = null;
                this.form.confirmNewPassword = null;
            }
        }
    }
</script>

<style scoped>
    .title {
        margin-top: 50px;
    }

    .label-title {
        font-weight: bold;
        font-size: 30px;
        position: relative;
        display: inline-block;
        width: calc(80% - 50px);
        margin: 0 calc(10% + 25px);
        text-align: center;
    }

    .back-btn {
        margin-left: -20px;
        position: absolute;
        cursor: pointer;
        font-size: 30px;
        font-weight: bold;
        z-index: 1;
    }

    .template {
        width: 40%;
        margin-left: 30%
    }

    .formPw {
        margin-top: 50px;
        text-align: left
    }

    .btnFoot {
        width: 60%;
    }

    @media only screen and (max-width: 1024px) {
        .template {
            width: 80%;
            margin-left: 10%;
            margin-right: 10%;
        }

    }

    @media only screen and (max-width: 450px) {
        .title {
            margin-top: 30px;
        }

        .label-title {
            font-size: 25px;
        }

        .back-btn {
            font-size: 20px;
            margin-left: 15px;
            margin-top: 9px;
            margin-bottom: 9px;
        }

        .template {
            width: 100%;
            margin-left: 0%;
        }

        .formPw {
            margin-top: 20px;
            width: 100%;
        }

        .btnFoot {
            width: 100%;
        }
    }

    @media only screen and (max-width: 360px) {
        .label-title {
            font-size: 20px;
        }

        .title {
            margin-top: 10px;
        }

        .back-btn {
            margin-top: 5px;
            margin-bottom: 5px;
        }

        .formPw {
            margin-top: 10px;
        }

    }

</style>